import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";

const Layout: React.FC = () => {
  const location = useLocation();

  // Exclude footer from /contact-us
  const hideFooterOn = ["/contact-us"];

  const shouldShowFooter = !hideFooterOn.includes(location.pathname);

  return (
    <>
      <Navbar />
      <main className="w-100">
        <Outlet />
      </main>
      {shouldShowFooter && <Footer />}
    </>
  );
};

export default Layout;
